import React from "react"
import { connect } from "react-redux"
import {
    selectIsEditableForCustomTagCell,
    selectOptionsForCustomTagCell,
    selectTagTypeForCustomTagCell,
} from "sheets/selectors/sheet-selectors"
import StatCell from "sheets/components/cells/StatCell"
import DefaultCell from "sheets/components/cells/DefaultCell"
import TagOptionCell from "sheets/components/cells/TagOptionCell"
import LargeTextCell from "sheets/components/cells/LargeTextCell"
import YesNoNullCell from "sheets/components/cells/YesNoNullCell"
import DateCell from "sheets/components/cells/DateCell"

const mapStateToProps = (state, ownProps) => ({
    isEditable: selectIsEditableForCustomTagCell(state, { id: ownProps.sheetId, ...ownProps }),
    options: selectOptionsForCustomTagCell(state, { id: ownProps.sheetId, ...ownProps }),
    tagType: selectTagTypeForCustomTagCell(state, { id: ownProps.sheetId, ...ownProps }),
})

const CustomTagCell = ({ options, tagType, ...props }) => {
    switch (tagType) {
        case DjangIO.app.person.types.TagType.boolean.value:
            return <YesNoNullCell {...props} />
        case DjangIO.app.person.types.TagType.number.value:
            return <StatCell {...props} />
        case DjangIO.app.person.types.TagType.single_option_list.value:
            return <TagOptionCell clearable options={options} {...props} />
        case DjangIO.app.person.types.TagType.multi_options_list.value:
            return <TagOptionCell clearable multi options={options} {...props} />
        case DjangIO.app.person.types.TagType.date.value:
            return <DateCell {...props} />
        case DjangIO.app.person.types.TagType.string.value:
            return <LargeTextCell {...props} />

        default:
            return <DefaultCell {...props} />
    }
}

export default connect((state, props) => mapStateToProps(state, props))(CustomTagCell)
